import React from 'react';
import ErrorImage from 'assets/images/v2/ic_error.png';
import './ErrorView.scss';
import { Button } from 'antd';
import { t } from 'helpers/i18n';

type ErrorViewProps = {
  errorText?: string;
  buttonText?: string;
  visibleErrorImage?: boolean;
  onButtonClick?: () => void;
};

const ErrorView: React.FC<ErrorViewProps> = ({
  errorText,
  buttonText,
  visibleErrorImage = true,
  onButtonClick,
}) => {
  const defaultRetry = () => {
    window.location.reload();
  };

  return (
    <div className="common-error-view-container">
      {visibleErrorImage && <img src={ErrorImage} alt="Error" width={300} />}
      <p className="common-error-view-error-text">
        {errorText ?? t('SomethingWentWrong')}
      </p>
      <Button type="primary" onClick={onButtonClick ?? defaultRetry}>
        {buttonText ?? t('Retry')}
      </Button>
    </div>
  );
};

export default ErrorView;
